import { Dispatch } from '@lumapps/redux/types';
import { BaseLoadingStatus } from '@lumapps/utils/types/BaseLoadingStatus';

import * as api from '../../api';
import { actions } from './slice';

export const fetchProgramsByIds = (programIds: string[]) => async (dispatch: Dispatch) => {
    dispatch(actions.setModalStatus(BaseLoadingStatus.loading));
    try {
        const { data } = await api.fetchPrograms({ ids: programIds });

        const programIdsByName = data?.items?.reduce((acc: any, program: any) => {
            acc[program.name?.value] = program.id;
            return acc;
        }, {});

        dispatch(actions.setProgramIdsByName(programIdsByName));
        dispatch(actions.setModalStatus(BaseLoadingStatus.idle));
    } catch (e) {
        dispatch(actions.setModalStatus(BaseLoadingStatus.error));
    }
};
